export default {
    affiliate: 1,
    affiliateGroup: 2,
    group: 3,
    rejection: 4
}